import { render, staticRenderFns } from "./ButtonRect.vue?vue&type=template&id=824a5aa0&scoped=true&"
import script from "./ButtonRect.vue?vue&type=script&lang=js&"
export * from "./ButtonRect.vue?vue&type=script&lang=js&"
import style0 from "./ButtonRect.vue?vue&type=style&index=0&id=824a5aa0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "824a5aa0",
  null
  
)

export default component.exports